// Has the app build that draws buttons reached both stores? The server decides, from what
// app_version_config says each store has, and refuses a send of its own accord: this is so the
// page can say why before anyone fills the form in. Until it knows, it holds: never a guess.

import { useEffect, useState } from 'react';
import { bannerAPI } from './bannerApi';

const CHECKING = 'Checking the app release…';
const COULD_NOT_CHECK = 'Held: we could not check whether the new app is in the stores';

export function useActionsRelease({ on, again }: { on: boolean; /** A new value reads it again. */ again: unknown }) {
  const [state, setState] = useState<{ released: boolean; reason: string; loading: boolean }>({
    released: false,
    reason: CHECKING,
    loading: true,
  });

  useEffect(() => {
    // Once out, it stays out, and a page left open has nothing more to ask.
    if (!on || state.released) return;
    let cancelled = false;
    bannerAPI
      .actionsRelease()
      .then((res) => {
        if (cancelled) return;
        const data = res.data?.data;
        setState({
          released: data?.released === true,
          reason: data?.released === true ? '' : data?.reason || COULD_NOT_CHECK,
          loading: false,
        });
      })
      .catch(() => {
        if (!cancelled) setState({ released: false, reason: COULD_NOT_CHECK, loading: false });
      });
    return () => {
      cancelled = true;
    };
    // Only a new tab or kind asks again.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [on, again]);

  return state;
}

export type ActionsReleaseState = ReturnType<typeof useActionsRelease>;
